import { auth, getAppCheckHeader } from '../firebase.js';
import { gatewayUrl } from './generate.js';

/**
 * Asks the `suggestTopics` Cloud Function for a handful of topic name
 * ideas, ordered simplest-to-most-advanced, for the "New topic" dialog.
 * Non-streaming — it's a small JSON response, not a full page.
 *
 * @param {object} opts
 * @param {string} opts.courseTitle
 * @param {string} [opts.courseDescription]
 * @param {string|null} [opts.parentTopicTitle] - set when creating a subtopic
 * @param {string[]} [opts.existingTitles] - sibling topic titles, to avoid duplicates
 * @returns {Promise<string[]>} suggestions, already ordered by increasing complexity
 */
export async function suggestTopicNames({ courseTitle, courseDescription, parentTopicTitle, existingTitles }) {
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in');
  const idToken = await user.getIdToken();

  const res = await fetch(gatewayUrl('suggestTopics'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Firebase-Auth': idToken,
      ...(await getAppCheckHeader()),
    },
    body: JSON.stringify({ courseTitle, courseDescription, parentTopicTitle, existingTitles }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Could not get suggestions (${res.status})`);
  }
  return Array.isArray(data.suggestions) ? data.suggestions : [];
}
